export default __webpack_public_path__ + "static/media/32.45bb6667.jpg";